// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { createHandlerChainRunner, Handler, HasOnError, HasOnSuccess } from "@insite/client-framework/HandlerCreator";
import { AssignedRolesModel, assignRolesToUser } from "@vanmeter/App/Services/VmiUserService";

type Parameter = AssignedRolesModel & HasOnSuccess & HasOnError<unknown>;

type Props = {
    apiParameter: AssignedRolesModel;
    error?: unknown;
};

type HandlerType = Handler<Parameter, Props>;

export const PopulateApiParameter: HandlerType = props => {
    props.apiParameter = { ...props.parameter };
};

export const AssignRolesToUser: HandlerType = async props => {
    const result = await assignRolesToUser(props.apiParameter);
    if (!result.successful) {
        props.error = result.errorMessage;
    }
};

export const ExecuteOnSuccessCallback: HandlerType = props => {
    if (!props.error) {
        props.parameter.onSuccess?.();
    }
};

export const ExecuteOnErrorCallback: HandlerType = props => {
    if (props.error) {
        props.parameter.onError?.(props.error);
    }
};

export const chain = [PopulateApiParameter, AssignRolesToUser, ExecuteOnSuccessCallback, ExecuteOnErrorCallback];

const assignVmiUserRoles = createHandlerChainRunner(chain, "assignVmiUserRoles");
export default assignVmiUserRoles;
